import { render, staticRenderFns } from "./HomeBusinessInfoComponent.vue?vue&type=template&id=54879da3&scoped=true&"
import script from "./HomeBusinessInfoComponent.vue?vue&type=script&lang=js&"
export * from "./HomeBusinessInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeBusinessInfoComponent.vue?vue&type=style&index=0&id=54879da3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54879da3",
  null
  
)

export default component.exports